import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HandledHttpClient } from '../api/handledHttpClient';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FeatureToggleService {
  private baseUrl: string;
  featureToggles: any;
  public featuresLoaded: BehaviorSubject<boolean> =
    new BehaviorSubject<boolean>(false);

  constructor(private http: HandledHttpClient) {
    this.baseUrl = environment.config.apis.vcall;
  }

  public LoadFeatures(): Promise<any> {
    let self = this;
    return self.http
      .get(`${self.baseUrl}/Application/features`)
      .toPromise()
      .then((data) => {
        self.featureToggles = data;
        self.featuresLoaded.next(true);
      });
  }

  public IsFeatureEnabled(name: string): boolean {
    if (!this.featureToggles) return false;
    if (name === FeatureEnum.SSNEncryption) {
      return this.featureToggles[name];
    }
    return false;
  }
}

export enum FeatureEnum {
  SSNEncryption = 'SSNEncryption',
}
